import type {Me} from "../types";

/** Support "view as user" — officer shift/break enforcement modals must not block the UI. */
export function isViewingAsUser(me: Me | null | undefined): boolean {
  return me?.impersonation?.active === true;
}
